// project-imports
import { deleteRequest, getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - BUCKET ||============================== //

export async function handleBucket(action: APIAction) {
  switch (action.method) {
    case 'read':
      return getRequest(`/bucket?path=${action.data.path}`);
    case 'size':
      return getRequest(`/bucket/size?path=${action.data.path}`);
    case 'download':
      return getRequest(`/bucket/download?key=${action.data.key}`);
    case 'check-exist':
      return postRequest('/bucket/check-exist', action.data.urlList);
    case 'carousel-images':
      return getRequest(`/bucket/carousel/${action.id}`);
    case 'presign-upload':
      return postRequest('/bucket/presign-upload', action.data);
    case 'presign-private-get': {
      const params = new URLSearchParams();
      if (action.data?.agentId) params.set('agent_id', action.data.agentId);
      const query = params.toString();
      const body: { key: string; local_agent?: boolean } = { key: action.data.key };
      if (action.data?.localAgent === true) body.local_agent = true;
      return postRequest(`/bucket/presign-private-get${query ? `?${query}` : ''}`, body);
    }
    case 'delete':
      return deleteRequest(`/bucket/delete?path=${action.data.path}`);
    default:
      console.info('[ApiManager > handleApiAction > handleBucket] - Unknown method');
      break;
  }
}
